/**
 *  A dedicated Reducer for Report State
 */

const initState = {
    yep_ph: null,
    yep_ph_ticket: null,
    loading: true,
    status: null,
    submitting: false,
    registration_summary: null,
    registration_rows: [],
    registration_loading: false,
    registration_status: null,
}

const modalReducers = (state = initState, action) => {
    let result = { ...state };
    switch (action.type) {
        case "FETCHED_YEP_PH":
            result = {
                ...state,
                yep_ph: action.content,
            }
            break;

        case "FETCHED_YEP_PH_TICKET":
            result = {
                ...state,
                yep_ph_ticket: action.ticket,
                loading: action.loading,
                status: action.status
            }
            break;
        case "FETCHED_EVENT_REGISTRATION_SUMMARY":
            console.log(action)
            return {
                ...state,
                registration_summary: action.summary,
                registration_rows: action.rows || [],
                registration_loading: false,
                registration_status: action.status,
            };
        case "FETCHING_EVENT_REGISTRATION_SUMMARY":
            return {
                ...state,
                registration_loading: true,
                registration_status: null,
                registration_rows: []
            };
        default:
            result = state;
    }
    return result;
}

export default modalReducers;